import { useParams, useLocation } from 'react-router-dom'

import BreadCrumbs from 'components/Header/BreadCrumbs'

export default function KinesisProfileBreadCrumbs({ 
    propProfileType = 'individual', 
    profileName = null, 
    showSettingsCrumb = true, 
    currentPageName = null 
}) {

    const { urlGroupId, urlAthleteId } = useParams()
    const location = useLocation()

    const profilePath = propProfileType === 'group' ? `/group/${urlGroupId}` : `/athlete/${urlAthleteId}`

    const crumbs = [
        { name: propProfileType === 'group' ? 'Groups' : 'Athletes', path: propProfileType === 'group' ? '/groups' : '/athletes' },
        { name: profileName ?? (propProfileType === 'group' ? 'Group' : 'Athlete'), path: profilePath },
    ]

    if (showSettingsCrumb) {
        crumbs.push({ name: 'Settings', path: `${profilePath}/settings` })
    }

    if (currentPageName != null) {
        crumbs.push({ name: currentPageName, path: location.pathname, state: location.state })
    }

    return <BreadCrumbs crumbs={crumbs} />
}
